@use '@fukuri-admins/ui/layout' as *;

/* メインのWrapper */
.wrapper {
  position: fixed;
  z-index: 2000;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
